import React, {useState} from 'react';
import {useStores} from "../../../stores/Context";
import BtnPrimary from "../../../boiteAOutils/BtnPrimary";
import {QRCodeSVG} from 'qrcode.react';
const WidgetBibliothequeImageUploadQrCode = () => {
    const {widgetStore, bibliothequeImagesStore} = useStores();

    const [image, setImage] = useState(null);
    const [imageUrl, setImageUrl] = useState("");

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            setImageUrl(url);
            setImage(file);
        }
    };

    return (
        <div className={"consigneModifyBody"} >

            <div className={"consigneModifyHeader"}>
                <h3 className={"consigneModifyTitleH3"}>
                    Uploader une Image via QR Code
                </h3>
                <div onClick={() => bibliothequeImagesStore.handleCloseUploadQrCode()} style={{ cursor: "pointer", rotate: "180deg" }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"/>
                        <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"/>
                        <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"/>
                    </svg>
                </div>
            </div>
            <div className={"consigneModifyHeaderSeparateur"}></div>

            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', marginTop: '3em'}}>

                <p>Scannez ce QR Code avec votre mobile pour uploader une image :</p>
                <QRCodeSVG value={window.location.href} size={200} />
                <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    id="imageUpload"
                    onChange={handleImageUpload}
                />

                {imageUrl && (
                    <div className="w-full flex flex-col items-center gap-2">
                        <img src={imageUrl} alt="Prévisualisation" className="w-64 h-64 object-cover rounded-lg border" />
                        <a href={imageUrl} download="uploaded_image.jpg" className="mt-2">
                            <BtnPrimary>Télécharger l’image</BtnPrimary>
                        </a>
                    </div>
                )}
            </div>
            
        </div>
    );
};

export default WidgetBibliothequeImageUploadQrCode;